import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import AppInput from '../../../../common/AppInput';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import { FIELDS } from './validation/fields';
import { COMPLETE_FORM } from '../../../../../constants/texts';
import { useExtendValidityStyles } from './styles';
import { textMapper } from '../../../../../helpers/FormHelper';

const Form = ({ ...props }) => {
  const { onData, mobile, state, motiveId } = props;
  const classes = useExtendValidityStyles({ mobile });

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      <Typography className={classes.title}>{COMPLETE_FORM}</Typography>

      {FIELDS.map((field, index) => (
        <AppInput
          key={index}
          onChange={handleChange}
          onBlur={() => {}}
          onClick={() => {}}
          disabled={state[field.name]?.disabled || false}
          name={field.name}
          error={state[field.name]?.error || false}
          type={state[field.name]?.type || ''}
          label={state[field.name]?.label || ''}
          required={state[field.name]?.required || false}
          inputAdornment={state[field.name]?.inputAdornment || ''}
          success={state[field.name]?.success || false}
          helperText={state[field.name]?.helper || ''}
          multiline={state[field.name]?.multiline || false}
          rows={state[field.name]?.rows || ''}
          value={state[field.name]?.value || ''}
          errorMessage={state[field.name]?.message || ''}
        />
      ))}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
};

export default Form;
